module.exports = __webpack_public_path__ + "img/whiteTick.7fee26d7.svg";